import React from 'react';
import * as S from './styled';
import StaticText from '../StaticText';
import RadioButton from '../RadioButton';
import { openPDF } from '../../utils/utils';

const GeneralConditions = ({ checked, onChangeBtn, text, productCode }) => (
  <>
    <S.Wrapper>
      <StaticText size={12} alignLeft>
        É superimportante que você leia as condições gerais e aceite as regras
        do seu plano de Capitalização.
      </StaticText>
      <S.Button onClick={() => openPDF(productCode)}>
        Condições gerais - PDF
      </S.Button>
    </S.Wrapper>
    <RadioButton
      dark
      alignLeft
      checked={checked}
      onChange={onChangeBtn}
      text={text}
    />
  </>
);

export default GeneralConditions;
